export default __webpack_public_path__ + "static/media/DentalBackground.f76a846b.svg";